__turbopack_context__.v({
  "passport_compass_rose_icon": "PassportLockup-module-scss-module__RMx4HW__passport_compass_rose_icon",
  "passport_lockup": "PassportLockup-module-scss-module__RMx4HW__passport_lockup",
});
